import { render, staticRenderFns } from "./ChartCompetitionPlayers.vue?vue&type=template&id=5b6ffcf1&scoped=true&"
import script from "./ChartCompetitionPlayers.vue?vue&type=script&lang=js&"
export * from "./ChartCompetitionPlayers.vue?vue&type=script&lang=js&"
import style0 from "./ChartCompetitionPlayers.vue?vue&type=style&index=0&id=5b6ffcf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ffcf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6ffcf1')) {
      api.createRecord('5b6ffcf1', component.options)
    } else {
      api.reload('5b6ffcf1', component.options)
    }
    module.hot.accept("./ChartCompetitionPlayers.vue?vue&type=template&id=5b6ffcf1&scoped=true&", function () {
      api.rerender('5b6ffcf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChartCompetitionPlayers.vue"
export default component.exports